// Signed-in playback cookies expire (D34: 6 hours). The watch page asks for a new session when the
// tab comes back near or after that time; a missing or unreadable expiry never triggers a request.
export const PLAYBACK_RENEWAL_MARGIN_MS = 10 * 60 * 1000

const expiryMs = expiresAt => {
  if (expiresAt instanceof Date) return expiresAt.getTime()
  if (typeof expiresAt === 'number') return expiresAt
  if (typeof expiresAt === 'string' && expiresAt.trim()) return Date.parse(expiresAt)
  return NaN
}

export const shouldRenewPlayback = (expiresAt, nowMs, marginMs = PLAYBACK_RENEWAL_MARGIN_MS) => {
  const expires = expiryMs(expiresAt)
  if (!Number.isFinite(expires) || !Number.isFinite(nowMs)) return false
  return nowMs >= expires - marginMs
}

// Signed-in playback cookies are shared by every tab and every video, and allow only the video whose session
// was issued last. The watch page notes that video here, so a tab coming back can tell that another tab has
// since taken the cookies for a different video, and take them back.
export const PLAYBACK_SESSION_KEY = 'highlights.playbackSessionUpload'

const storage = () => {
  try {
    return typeof window !== 'undefined' ? window.localStorage : null
  } catch (_) {
    return null
  }
}

export const notePlaybackSession = uploadId => {
  try {
    storage()?.setItem(PLAYBACK_SESSION_KEY, uploadId)
  } catch (_) {}
}

// Only a noted session for another video counts; a missing or unreadable note never triggers a request.
export const playbackSessionReplaced = uploadId => {
  try {
    const last = storage()?.getItem(PLAYBACK_SESSION_KEY)
    return Boolean(last) && last !== uploadId
  } catch (_) {
    return false
  }
}
